import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    pageIndex: 1,
    pageSize: 10,
    globalSearch: "",
    role: null,
    sorting: null,
  },
  sortedColumn: null,
  sortedDirection: null,
  userList: [],
  isLoadingUsers: false,
};

const gestioneUtentiSlice = createSlice({
  name: "gestioneUtentiSlice",
  initialState,
  reducers: {
    setIsLoadingUsers: (state: any, action) => {
      state.isLoadingUsers = action.payload;
    },
    setUsers: (state: any, action: any) => {
      state.userList = [...action.payload];
    },
    nextPageUtenti: (state) => {
      state.filters.pageIndex++;
    },
    setPageUtentiAndSize: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: action.payload.page ?? state.filters.pageIndex,
        pageSize: action.payload.size ?? state.filters.pageSize,
      });
    },
    setPageUtenti: (state, action) => {
      state.filters.pageIndex = action.payload;
    },
    setSizeUtenti: (state, action) => {
      state.filters.pageSize = action.payload;
    },
    setSearchTermUtenti: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: 1,
        globalSearch: action.payload,
      });
    },
    setRoleUtenti: (state, action) => {
      Object.assign(state.filters, { pageIndex: 1, role: action.payload });
    },

    setSorting: (state, action) => {
      state.sortedColumn = action.payload.sortedColumn;
      state.sortedDirection = action.payload.sortedDirection;
      Object.assign(state.filters, {
        pageIndex: 1,
        sorting: action.payload.sorting,
      });
    },
    resetFiltersUtenti: () => {
      return initialState;
    },
  },
});

export const {
  nextPageUtenti,
  setPageUtenti,
  setSizeUtenti,
  setSearchTermUtenti,
  setRoleUtenti,
  setSorting,
  resetFiltersUtenti,
  setUsers,
  setPageUtentiAndSize,
  setIsLoadingUsers,
} = gestioneUtentiSlice.actions;

export default gestioneUtentiSlice.reducer;
